import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import { Icons } from '../../../../global';
import { InputAbstract } from '../base/input.abstract';
import { MatFormField, MatLabel, MatPrefix, MatSuffix, MatHint, MatError } from '@angular/material/form-field';
import { NgIf } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { MatInput } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRipple } from '@angular/material/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'slm-text-area',
    templateUrl: './text-area.component.html',
    styles: [`
    :host {
      flex-direction: row;
      box-sizing: border-box;
      display: flex;
    }
  `],
    imports: [MatFormField, NgIf, MatLabel, TranslateDirective, SvgIconComponent, MatPrefix, MatInput, FormsModule, ReactiveFormsModule, MatSuffix, MatRipple, MatTooltip, MatHint, MatError, TranslatePipe]
})
export class TextAreaComponent extends InputAbstract {
  @ViewChild('textArea') textArea: ElementRef;

  @Input() buttonIcon = true;
  @Input() enterEnabled = false;
  @Input() prefixIcon: Icons = null;
  @Input() suffixIcon: Icons = null;
  @Input() suffixIconLabel = '';
  @Input() maxRow = 5;
  @Input() minRow = 2;
  @Input() maxLength = 0;
  @Input('focusOnInput')
  public set setFocusOnInput(value: boolean) {
    if (value) {
      setTimeout(() => this.textArea?.nativeElement.focus(), 100);
    }
  }

  public clear(): void {
    if (this.control) {
      this.control.setValue('');
    }
  }
}
